import { BaseResponse, RequestConfig } from 'common/types/api'
import axios from 'core/api'

import { buildUrlWithParams } from 'utils/url'

import {
  ShrimpDisease,
} from './types'

export const DEATH_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/death' },
  getRecentSize: { method: 'GET', url: '/mortality/recent-size' },
  getLineChart: { method: 'GET', url: '/death/line-chart' },
  create: { method: 'POST', url: '/mortality' },
  edit: { method: 'PUT', url: '/mortality' },
  delete: { method: 'DELETE', url: '/mortality' },
  uploadImage: { method: 'POST', url: '/death/image' },
  getSummaryToday: { method: 'GET', url: '/death/today' },
}
export const getShrimpDiseases = (speciesId?: number) =>
  axios.get<BaseResponse<ShrimpDisease[]>>(buildUrlWithParams('/diseases', { speciesId }))